__turbopack_context__.v({
  "error": "lQyTra_error",
  "footer": "lQyTra_footer",
  "placeholder": "lQyTra_placeholder",
  "wrapper": "lQyTra_wrapper",
});
